module.exports = __webpack_public_path__ + "static/img/DaimlerCS-Demi.a6825e2f.svg";